var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossGreyed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0859 13.5286C13.3463 13.789 13.7683 13.789 14.0286 13.5286C14.289 13.2683 14.289 12.8463 14.0287 12.5859L11.4427 9.99999L14.0286 7.41405C14.289 7.15373 14.289 6.73167 14.0286 6.47135C13.7683 6.21103 13.3463 6.21103 13.0859 6.47135L10.5 9.05729L7.91405 6.47135C7.65373 6.21103 7.23167 6.21103 6.97135 6.47135C6.71103 6.73167 6.71103 7.15373 6.97135 7.41405L9.55729 9.99999L6.97135 12.5859C6.71103 12.8462 6.71103 13.2683 6.97135 13.5286C7.23167 13.7889 7.65373 13.789 7.91406 13.5286L10.5 10.9427L13.0859 13.5286Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGreyed);
export default __webpack_public_path__ + "static/media/Cross_Greyed.5b42f4a76b434494506b42f6996f9d96.svg";
export { ForwardRef as ReactComponent };